import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	sidebarTitle: {
		id: 'eoc-on-call.tours.get-started.sidebar-title',
		defaultMessage: 'Manage your team’s operations',
		description: 'Title of sidebar spotlight',
	},
	sidebarDescription: {
		id: 'eoc-on-call.tours.get-started.sidebar-description',
		defaultMessage:
			"This is where you'll find all the essential tools to manage your operations. Explore your team alerts, on-call schedules, integrations, and other configurations to set up your team for success.",
		description: 'Description of sidebar spotlight',
	},
	routingRuleTitle: {
		id: 'eoc-on-call.tours.get-started.routing-rule-title',
		defaultMessage: 'Customize alert routes',
		description: 'Title of Routing Rule spotlight',
	},
	routingRuleDescription: {
		id: 'eoc-on-call.tours.get-started.routing-rule-description',
		defaultMessage:
			'Improve alert response times by redirecting alerts to a more suitable escalation policy or schedule.',
		description: 'Description of Routing Rule spotlight',
	},
	escalationPoliciesTitle: {
		id: 'eoc-on-call.tours.get-started.escalation-policies-title',
		defaultMessage: 'Select the next person to escalate the alert',
		description: 'Title of Escalation Policies spotlight',
	},
	escalationPoliciesDescription: {
		id: 'eoc-on-call.tours.get-started.escalation-policies-description',
		defaultMessage:
			'Set up rules if the alert doesn’t get the necessary attention. Notify other people or an entire team and never miss a critical alert.',
		description: 'Description of Escalation Policies spotlight',
	},
	scheduleTitle: {
		id: 'eoc-on-call.tours.get-started.schedule-title',
		defaultMessage: 'Build flexible schedules for responsive teams',
		description: 'Title of Schedule spotlight',
	},
	scheduleDescription: {
		id: 'eoc-on-call.tours.get-started.schedule-description',
		defaultMessage:
			'Create customized on-call scenarios with flexible rotation features. Ensure your team stays responsive and prepared at all times.',
		description: 'Description of Schedule spotlight',
	},
});
